import React, { useEffect, useRef, useState } from "react";
import Banner from "../../../components/Banner";
import { useDispatch, useSelector } from "react-redux";
import { selectUserDetails } from "../../../redux/features/auth/authSlice";
import FeaturedCourses from "../../../components/Home/FeaturedCourses";
import Slider from "../../../components/Home/Slider";
import AboutUs from "../../../components/Home/AboutUs/AboutUs";
import MentorsFunction from "../../../components/Home/MentorsFunction";
import ContactUs from "../ContactUs/ContactUs";

const Home = () => {
    const dispatch = useDispatch();
    const modalRef = useRef(null);

    const { isLoggedIn } = useSelector(selectUserDetails);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Banner />
            <Slider/>
            <section id="courses"><FeaturedCourses /></section>            
             <section id="about"><AboutUs/></section>
            {/* <MentorsFunction/> */}
             <section id="contact"><ContactUs/></section>
        </>

    )
}

export default Home;